/*
  这个自定义钩子 `useChangeSearchParams` 旨在方便在 Next.js 应用程序中轻松操作搜索参数。它利用了 Next.js 的导航和路由工具以及 React 的状态管理功能。

  使用示例:

  // 导入钩子
  import { useChangeSearchParams } from "./useChangeSearchParams"

  // 在函数组件中使用
  const Component = () => {
    // 初始化钩子
    const { paramsObj, setParamsObj } = useChangeSearchParams()

    // 示例 1: 更新单个参数
    const updateParam = () => {
      // 创建一个包含更新参数的新对象
      const updatedParams = { ...paramsObj, key: "newValue" }
      // 调用 setParamsObj 更新 URL
      setParamsObj(updatedParams)
    }

    // 示例 2: 添加新参数
    const addParam = () => {
      // 创建一个包含额外参数的新对象
      const newParams = { ...paramsObj, newKey: "value" }
      // 调用 setParamsObj 更新 URL
      setParamsObj(newParams)
    }

    // 示例 3: 删除参数
    const removeParam = () => {
      // 创建一个不包含要删除参数的新对象
      const { paramToRemove, ...remainingParams } = paramsObj
      // 调用 setParamsObj 更新 URL
      setParamsObj(remainingParams)
    }

    return (
      <div>
        <button onClick={updateParam}>更新参数</button>
        <button onClick={addParam}>添加参数</button>
        <button onClick={removeParam}>删除参数</button>
      </div>
    )
  }

  注意: 在 Next.js 应用程序的函数组件中导入和使用此钩子。
*/

import {
  usePathname, useRouter, useSearchParams
} from "next/navigation"
import {
  useCallback
} from "react"

export const useChangeSearchParams = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const router = useRouter()

  const params = new URLSearchParams(searchParams.toString())
  const paramsObj = Object.fromEntries(params.entries())

  const createQueryString = useCallback((paramsObj) => {
    const params = new URLSearchParams()

    for (const key in paramsObj) {
      params.set(key, paramsObj[key])
    }

    return params.toString()
  }, [])

  const setParamsObj = (paramsObj) => {
    router.push(pathname + "?" + createQueryString(paramsObj))
  }

  return {
    paramsObj, setParamsObj
  }
}
